const handleLottie = (key, contentData) => {
    let gender = localStorage.getItem('gender').replaceAll('"', '');
    let age = localStorage.getItem('age').replaceAll('"', '');
    let lottie = contentData.options[0].radio_button[key - 1].gender[gender][age <= 34 ? 'below35' : age > 34 && age <= 59 ? 'above35' : 'above72']
    return lottie

}

export default handleLottie;